'use client';

import { useEffect, useSyncExternalStore } from 'react';

import { useInstallPlatform } from '@/hooks/use-install-platform';
import { AnalyticsEvent, track } from '@/lib/analytics/tracker';
import {
  closeInstallHelp,
  getHomeScreenAppState,
  getServerHomeScreenAppState,
  openInstallHelp,
  subscribeToHomeScreenApp,
} from '@/lib/home-screen-app-store';
import { INSTALL_ACTION } from '@/lib/install-platform';
import { InstallHelpSheet } from './install-help-sheet';

// The one place the help is rendered, so the account menu, the booking
// receipt and a printed /?action=install link all open the same sheet.
// Mounted from the (site) layout only: never in an embed or the preview.
export const HomeScreenApp = () => {
  const platform = useInstallPlatform();
  const { prompt, openFrom } = useSyncExternalStore(
    subscribeToHomeScreenApp,
    getHomeScreenAppState,
    getServerHomeScreenAppState
  );

  useEffect(() => {
    if (!platform) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('action') !== INSTALL_ACTION) return;
    url.searchParams.delete('action');
    window.history.replaceState(window.history.state, '', url);
    openInstallHelp('link');
  }, [platform]);

  useEffect(() => {
    const onInstalled = () =>
      track({
        event: AnalyticsEvent.APP_INSTALLED,
        properties: { platform: platform ?? 'unsupported' },
      });
    window.addEventListener('appinstalled', onInstalled);
    return () => window.removeEventListener('appinstalled', onInstalled);
  }, [platform]);

  if (!platform || !openFrom) return null;
  return (
    <InstallHelpSheet
      platform={platform}
      source={openFrom}
      prompt={prompt}
      onClose={closeInstallHelp}
    />
  );
};
